import React from 'react';
import { useTranslation } from 'react-i18next';

const CapacityGasDraftHeader = () => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold px-3">
      <div className="row no-gutters align-items-center">
        <div className="col-sm-5 col-lg-4">
          {tLabels("capacityGasDraftHeader.timePeriod")}
        </div>
        <div className="col-sm-3 col-lg-4 text-center">
          {tLabels("capacityGasDraftHeader.capacity")} <small>[m<sup>3</sup>]</small>
        </div>
        <div className="col-sm-2 text-center">
          {tLabels("capacityGasDraftHeader.type")}
        </div>
        <div className="col-sm-2 text-right">
          {tLabels("capacityGasDraftHeader.state")}
        </div>
      </div>
    </div>
  )
}

export default CapacityGasDraftHeader;